<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog persistent
                  v-model="$store.getters.bookAllocatorFileModal"
                  max-width="500">

            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Αρχεία
                </v-card-title>

                <v-card-text class="mt-5">
                    <v-row>
                        <v-col>
                            <v-file-input ref="pathToCover" accept=".gif, .jpeg, .jpg"  @change="saveCover" label="Εξώφυλλο" outlined dense></v-file-input>
                        </v-col>
                        <v-col>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="!disableIcon(cover)" v-on="on" large class="ml-5" color="primary" @click="showBook(1)">visibility</v-icon>
                                </template>
                                <span>Επισκόπηση</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="!disableIcon(cover)" @click="deletePathFile('cover')" v-on="on" large class="ml-5" color="red">delete</v-icon>
                                </template>
                                <span>Διαγραφή</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-file-input ref="pathToToc" accept=".pdf"  :rules="rulesOfPDF" @change="saveToc" label="Πίνακας Περιεχομένων" outlined dense></v-file-input>
                        </v-col>
                        <v-col>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="!disableIcon(toToc)" v-on="on" large class="ml-5" color="primary" @click="showBook(2)">visibility</v-icon>
                                </template>
                                <span>Επισκόπηση</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="!disableIcon(toToc)" @click="deletePathFile('toc')" v-on="on" large class="ml-5" color="red">delete</v-icon>
                                </template>
                                <span>Διαγραφή</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-file-input ref="pathToFile" accept=".pdf"  :rules="rulesOfPDF"  @change="saveFulltext" label="Πλήρες Κείμενο" outlined dense
                                          :background-color="$store.getters.editPublisherBook.pathToFile ? '' : 'red'"></v-file-input>
                        </v-col>
                        <v-col>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="!disableIcon(fullText) ? true : $store.getters.editPublisherBook.length > 0 ? true : false" v-on="on" large class="ml-5" color="primary" @click="showBook(3)">visibility</v-icon>
                                </template>
                                <span>Επισκόπηση</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon :disabled="!disableIcon(fullText) ? true : $store.getters.editPublisherBook.length > 0 ? true : false" @click="deletePathFile('file')" v-on="on" large class="ml-5" color="red">delete</v-icon>
                                </template>
                                <span>Διαγραφή</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-progress-linear
                            v-if="$store.getters.fileUpload"
                            color="primary"
                            indeterminate
                            rounded
                            height="6"
                    ></v-progress-linear>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                           color="primary"
                           text
                           @click="closeModal">
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import request from '../../../requests'
    import utils from '../../../utilities'
    import {eventBus} from "../../../main";

    export default {
        name: "BookAllocatorFiles",
        data: () => ({
            utils,
            progress: false,
            pathToCoverValue: null,
            pathToBackcoverValue: '',
            pathToTOCValue: '',
            pathToChapterValue: '',
            rulesOfPDF: [
                value => !value || value.size < 34000000 || 'Αρχείο pdf (.pdf) μεγέθους έως 34MB!',
            ],
        }),

        props: {
            pathToCover: String,
            pathToFile: String,
            pathToTOC: String,
            bookId: Number
        },

        methods: {

            closeModal() {

                this.$store.commit('setBookAllocatorFileModal', false);
            },

            saveCover(file) {
                this.upLoadFile(file, 'cover');
            },

            saveFulltext(file) {
                this.upLoadFile(file, 'full');
            },

            saveToc(file){
                this.upLoadFile(file, 'toc');
            },

            upLoadFile(file, type){
	            document.activeElement.blur();
                if (file != undefined) {
                    const formData = new FormData();
                    formData.append(type, file);
                    var token = utils.getLocalStorage('token');
                    if (token != null) {
                        this.$store.commit('setFileUpload', true);
                        request.upLoadFileToServlet(token, type, this.$store.getters.editPublisherBook.id,  formData, this.upLoadFileToServletCallBack)
                    }
                    else {
                        this.$store.commit('setloginModal', true);
                    }
                }
            },

            upLoadFileToServletCallBack(response) {
	            document.activeElement.blur();
                var publisherBooks = this.$store.getters.publisherBooks;

                for (var i = 0; i< publisherBooks.length; i++) {
                    if (publisherBooks[i].id == response.id) {
                        publisherBooks.splice(i,1,response);
                        break;
                    }
                }
                this.$store.commit('setPublisherBooks', publisherBooks);
                this.$store.commit('setEditPublisherBook', response);
                this.$store.commit('setFileUpload', false);
            },

            deletePathFile(type) {
	            document.activeElement.blur();
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    var fileObjc = {
                        bookId: this.$store.getters.editPublisherBook.id,
                        fileToRemove: type
                    };
                    this.$store.commit('setFileUpload', true);
                    this.resetInput(type);
                    request.deletefileFromServer(token, fileObjc, this.upLoadFileToServletCallBack)
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            resetInput(type) {

                switch (type) {

                    case 'cover':
                        this.$refs.pathToCover.reset();
                        break;
                    case 'toc':
                        this.$refs.pathToToc.reset();
                        break;
                    default:
                        this.$refs.pathToFile.reset();

                }
            },


            //    show the book in new tab
            showBook(cover){
	            document.activeElement.blur();
                var data = this.$store.getters.editPublisherBook;
                if (cover == 1 && data.pathToCover != null ) {
                    var url = data.pathToCover;
                    window.open(utils.containsPathToBook(url,'_blank'));
                }
                else if (cover == 2 && data.pathToTOC != null) {
                    var url = data.pathToTOC;
                    window.open(utils.containsPathToBook(url,'_blank'));
                }
                else {
                    if (data.pathToFile != null) {
	                    let reqObj={
		                    pathToFile:data.pathToFile
	                    };
	                    request.putForFiles('rest/allocator/get-book-pdf', reqObj);
                    }
                }
            },

            //    diasble icon
            disableIcon(path){

                return path != null && path != '';
            },
        },

        computed: {

            cover: function () {

                return this.$store.getters.editPublisherBook.pathToCover;
            },

            toToc: function () {

                return this.$store.getters.editPublisherBook.pathToTOC;
            },

            fullText: function () {

                return this.$store.getters.editPublisherBook.pathToFile;
            }
        },
    }
</script>

<style scoped>

</style>